import t from '@jetshop/intl';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import { SortOrders } from './SortOrders';
import { styled } from 'linaria/react';
import React, { Component } from 'react';
import { ActiveFilters } from './ActiveFilters';
import { BooleanFilters } from './BooleanFilters';
import FilterDrawer from './FilterDrawer';
import { ListFilters } from './ListFilters';
import { MultiListFilters } from './MultiListFilters';
import { RangeFilters } from './RangeFilters';
import FilterButton from './Mobile/FilterButton';

const OuterWrapper = styled('div')``;
const Filters = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > div {
    width: 100%;
    position: relative;
  }
  [data-flight-dropdown-items] {
    position: relative;
    border: 0;
    top: auto;
    display: flex;
    flex-wrap: wrap;
    &:focus {
      border: none;
    }
  }

  h3 {
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    margin: 0;
    padding: 1.2rem 0;
    border-bottom: 1px solid #dedede;
    width: 100%;
  }

  .boolean-wrapper {
    padding: 1.2rem 0;
  }
`;

const FiltersSectionWrapper = styled('div')`
  display: flex;
  flex-direction: row;
`;

const FiltersWapper = styled('div')`
  width: 90%;
`;
const SortWrapper = styled('div')`
  width: 100%;
  margin-bottom: 2rem;

  > div {
    width: 100%;
  }

  [data-flight-dropdown-items] {
  }
  [data-flight-dropdown-item] {
    width: 100%;
  }
`;

class Filter extends Component {
  render() {
    const { filters } = this.props;
    const sortOrders = this?.props?.sortOrders ?? [];
    return (
      <>
        <Above breakpoint="lg">
          {matches =>
            matches && (
              <OuterWrapper>
                <FiltersSectionWrapper>
                  <FiltersWapper>
                    <Filters>
                      {sortOrders?.length > 0 && (
                        <SortWrapper>
                          <h3>{t('Sort by')}:</h3>
                          <SortOrders sortOrders={sortOrders} />
                        </SortWrapper>
                      )}
                    </Filters>
                    <Filters>
                      <h3>{t('Filter')}:</h3>
                      <ListFilters filters={filters} />
                      <RangeFilters filters={filters} />
                    </Filters>
                    <Filters>
                      <MultiListFilters filters={filters} />
                    </Filters>
                    <Filters>
                      <div className="boolean-wrapper">
                        <BooleanFilters filters={filters} />
                      </div>
                    </Filters>
                  </FiltersWapper>
                </FiltersSectionWrapper>
                <ActiveFilters filters={filters} />
              </OuterWrapper>
            )
          }
        </Above>
        <Below breakpoint="lg">
          {matches =>
            matches && (
              <>
                <DrawerTrigger id="filterDrawer">
                  {({ showTarget }) => (
                    <FilterButton showTarget={showTarget} filters={filters} />
                  )}
                </DrawerTrigger>

                <DrawerTarget id="filterDrawer">
                  {({ hideTarget, isOpen }) => (
                    <Drawer isOpen={isOpen} right>
                      <FilterDrawer
                        close={hideTarget}
                        filters={filters}
                        sortOrders={sortOrders}
                      />
                    </Drawer>
                  )}
                </DrawerTarget>
              </>
            )
          }
        </Below>
      </>
    );
  }
}

export default Filter;
